// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"26e8f4ce","498":"43112e25","703":"26064dfd","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};